module.exports = __webpack_public_path__ + "static/media/AngleUpIcon_Dark.5c7e81cc.svg";